import request from "@js/web/request/Axios";

//获取2.0新游戏库信息
export function apiGetNewGameLibrary(
  data: pro.yunpb.IGetNewGameLibraryReq
): Promise<pro.yunpb.IGetNewGameLibraryRes> {
  return request({
    reqDesction: "GetNewGameLibraryReq",
    resDesction: "GetNewGameLibraryRes",
    funcName: "GetNewGameLibrary",
    serverName: "chikii.web.WebExtObj",
    data,
    showNotification: false,
  });
}

//社群内页
export function apiGetCommunityDetail(
  data: pro.yunpb.IGetCommunityDetailReq
): Promise<pro.yunpb.IGetCommunityDetailRes> {
  return request({
    reqDesction: "GetCommunityDetailReq",
    resDesction: "GetCommunityDetailRes",
    funcName: "GetCommunityDetail",
    serverName: "chikii.web.WebExtObj",
    useSocket: true,
    data,
    showNotification: false,
  });
}

// 获取游戏
export function apiGetGameRoomInfo(
  data: pro.yunpb.IGetGameRoomInfoReq
): Promise<pro.yunpb.IGetGameRoomInfoRsp> {
  return request({
    reqDesction: "GetGameRoomInfoReq",
    resDesction: "GetGameRoomInfoRsp",
    funcName: "GetGameRoomInfo",
    serverName: "chikii.node.NodeExtObj",
    useSocket: true,
    data,
    showNotification: false,
  });
}

// 输入框搜索
export function apiSearchCommunity(
  data: pro.yunpb.ISearchCommunityReq
): Promise<pro.yunpb.ISearchCommunityRes> {
  return request({
    reqDesction: "SearchCommunityReq",
    resDesction: "SearchCommunityRes",
    funcName: "SearchCommunity",
    serverName: "chikii.search.SearchExtObj",
    data,
    showNotification: false,
  });
}

// 获取商品详情
export function apiMallGoodsDetail(
  data: pro.yunpb.IGetMallGoodsDetailReq
): Promise<pro.yunpb.IGetMallGoodsDetailRes> {
  return request({
    reqDesction: "GetMallGoodsDetailReq",
    resDesction: "GetMallGoodsDetailRes",
    funcName: "MallGoodsDetail",
    serverName: "chikii.web.WebExtObj",
    data,
    useSocket: true,
    showNotification: false,
  });
}

// 获取商品详情
export function apiIsDeliveryCompleted(
  data: pro.yunpb.IIsDeliveryCompletedReq
): Promise<pro.yunpb.IIsDeliveryCompletedRes> {
  return request({
    reqDesction: "IsDeliveryCompletedReq",
    resDesction: "IsDeliveryCompletedRes",
    funcName: "IsDeliveryCompleted",
    serverName: "chikii.web.WebExtObj",
    data,
    showNotification: false,
  });
}

// 获取商品支付方式数据
export function apiGetGoodsPaymentWay(
  data: pro.yunpb.IGetGoodsPaymentWayReq
): Promise<pro.yunpb.IGetGoodsPaymentWayRes> {
  return request({
    reqDesction: "GetGoodsPaymentWayReq",
    resDesction: "GetGoodsPaymentWayRes",
    funcName: "GetGoodsPaymentWay",
    serverName: "chikii.store.StoreExtObj",
    data,
    useSocket: true,
    showNotification: false,
  });
}

// 获取商品支付方式数据
export function apiOrderGoods(
  data: pro.yunpb.IOrderGoodsReq
): Promise<pro.yunpb.IOrderGoodsRes> {
  return request({
    reqDesction: "OrderGoodsReq",
    resDesction: "OrderGoodsRes",
    funcName: "OrderGoods",
    serverName: "chikii.store.StoreExtObj",
    data,
    useSocket: true,
    showNotification: false,
  });
}

// 获取商品支付信息，通过订单id
export function apiGetOrderInfoByOrderId(
  data: pro.yunpb.IGetOrderInfoByOrderIdReq
): Promise<pro.yunpb.IGetOrderInfoByOrderIdRes> {
  return request({
    reqDesction: "GetOrderInfoByOrderIdReq",
    resDesction: "GetOrderInfoByOrderIdRes",
    funcName: "GetOrderInfoByOrderId",
    serverName: "chikii.store.StoreExtObj",
    data,
    useSocket: true,
    showNotification: false,
  });
}
